import { AppData } from 'types/AppData';

export const appData: AppData = (window as any).__partaj_frontend_context__;
